import React from 'react';
import QRCode from 'qrcode.react';
import {generateWhatsappUrl} from '../../../utils/urls';
import ClipboardCopyInput from '../../ClipboardCopyInput';

const WhatsappInfo = ({values}) => (
    <div className="text-center">
        <QRCode value={generateWhatsappUrl(values.code)} size={256} level="M" className="my-4" />
        <ClipboardCopyInput readOnly value={generateWhatsappUrl(values.code)} />
    </div>
);

export default WhatsappInfo;
